import classnames from 'classnames/bind'
import * as styles from './index.module.css'

const cx = classnames.bind(styles)

export default function Icon({ id, className, color }) {
  switch (id) {
    case 'change':
      return (
        <svg width="18" height="5" viewBox="0 0 18 5" className={cx(styles.svg, className)} xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="2.5" r="2" />
          <circle cx="9" cy="2.5" r="2" />
          <circle cx="2" cy="2.5" r="2" />
        </svg>
      )
    case 'pin':
      return (
        <svg width="16" height="19" viewBox="0 0 16 19" className={cx(styles.svg, className)} fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M2.34315 2.34315C-0.781049 5.46734 -0.781049 10.5327 2.34315 13.6569L6.58579 17.8995C7.36684 18.6805 8.63317 18.6805 9.41421 17.8995L13.6569 13.6569C16.781 10.5327 16.781 5.46734 13.6569 2.34315C10.5327 -0.781049 5.46734 -0.781049 2.34315 2.34315ZM8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5Z" fill="#17181A"/>
        </svg>
      )
    case 'pen':
      return (
        <svg width="11" height="11" viewBox="0 0 11 11" className={cx(styles.svg, className)} fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M10.1224 2.81944C10.4194 2.52243 10.5679 2.37393 10.6235 2.20268C10.6725 2.05205 10.6725 1.88979 10.6235 1.73915C10.5679 1.56791 10.4194 1.4194 10.1224 1.12239L9.84853 0.848528C9.55152 0.551515 9.40301 0.403009 9.23176 0.347368C9.08113 0.298424 8.91887 0.298424 8.76824 0.347368C8.59699 0.403009 8.44848 0.551516 8.15147 0.848528L7.6839 1.3161L9.65481 3.28702L10.1224 2.81944ZM6.89553 2.10447L0.711589 8.28841C0.569303 8.4307 0.49816 8.50184 0.443481 8.58364C0.394966 8.65621 0.356162 8.73483 0.328061 8.81749C0.296391 8.91064 0.28319 9.01038 0.25679 9.20986L0.106468 10.3457C0.0840982 10.5147 0.0729136 10.5993 0.100023 10.6624C0.123795 10.7179 0.166789 10.7628 0.221086 10.789C0.283011 10.8189 0.367939 10.8115 0.537795 10.7967L1.71856 10.6936C1.93347 10.6748 2.04092 10.6655 2.14146 10.6347C2.23065 10.6075 2.31559 10.5679 2.39381 10.5171C2.48199 10.4598 2.55826 10.3836 2.7108 10.231L8.86645 4.07538L6.89553 2.10447Z" fill="#17181A"/>
        </svg>
      )
    case 'drag':
      return (
        <svg width="16" height="10" fill="black" fillOpacity="0.5" className={cx(className)} viewBox="0 0 16 10" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 4h16v2H0zm0-4h16v2H0zm0 8h16v2H0z"/>
        </svg>
      )
    case 'plus':
      return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="black" fillOpacity="0.5" className={cx(className)} xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M9 11V15H11V11H15V9H11V5H9V9H5V11H9Z" />
        </svg>
      )
    case 'white-minus':
      return (
        <svg width="10" height="10" viewBox="0 0 10 2" fill="none" stroke="#FFF" strokeWidth="2" className={cx(className)} xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1h10"/>
        </svg>
      )
    case 'white-plus':
      return (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="#FFF" strokeWidth="2" className={cx(className)} xmlns="http://www.w3.org/2000/svg">
          <path d="M5 0v10M0 5h10"/>
        </svg>
      )
    case 'suitcase':
      color = color || 'white'
      return (
        <svg width="16" height="13" fill="none" className={cx(className)} xmlns="http://www.w3.org/2000/svg">
          <path fill={color} d="M1.333 5.3c0-.747 0-1.12.146-1.405.127-.251.331-.455.582-.583.285-.145.659-.145 1.406-.145h9.066c.747 0 1.12 0 1.406.145.25.128.454.332.582.583.146.285.146.658.146 1.405v5.067c0 .746 0 1.12-.146 1.405-.128.25-.332.455-.582.583-.286.145-.659.145-1.406.145H3.467c-.747 0-1.12 0-1.406-.145a1.33 1.33 0 0 1-.582-.583c-.146-.285-.146-.659-.146-1.405z"/>
          <path stroke={color} strokeLinecap="round" strokeLinejoin="round" d="M10.667 3.167c0-.62 0-.93-.069-1.185A2 2 0 0 0 9.184.568C8.93.5 8.62.5 8 .5s-.93 0-1.184.068A2 2 0 0 0 5.4 1.982c-.068.255-.068.565-.068 1.185M3.467 12.5h9.066c.747 0 1.12 0 1.406-.145.25-.128.454-.332.582-.583.146-.285.146-.659.146-1.405V5.3c0-.747 0-1.12-.146-1.405a1.33 1.33 0 0 0-.582-.583c-.286-.145-.659-.145-1.406-.145H3.467c-.747 0-1.12 0-1.406.145-.25.128-.455.332-.582.583-.146.285-.146.658-.146 1.405v5.067c0 .746 0 1.12.146 1.405.127.25.331.455.582.583.285.145.659.145 1.406.145"/>
        </svg>
      )
    default: 
      return null
  }
}
